import { Volume2 } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

import { buttonVariants } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { cn } from "@/lib/utils";

export function SelectSpeaker() {
  const vidyoSDK = useVidyoStore((state) => state.vidyoSDK);

  const speakers = useVidyoStore((state) => state.speaker.available);
  const selectedSpeaker = useVidyoStore(
    useShallow((state) => ({
      id: state.speaker.selected?.id,
      name: state.speaker.selected?.name,
    })),
  );
  const setPreferredSpeaker = useVidyoStore(
    (state) => state.speaker.setPreferred,
  );

  const handleSelectSpeaker = async (speakerId: string) => {
    const speaker = speakers.find((s) => s.id === speakerId);
    if (speaker) {
      await vidyoSDK?.SelectLocalSpeaker({
        localSpeaker: speaker,
      });
      setPreferredSpeaker(speaker);
    }
  };

  return (
    <Select value={selectedSpeaker?.id} onValueChange={handleSelectSpeaker}>
      <SelectTrigger
        className={cn(buttonVariants({ variant: "ghost" }), "justify-normal")}
      >
        <Volume2 className="mr-2 h-4 w-4 flex-shrink-0" />

        <span className="inline-block truncate">
          {selectedSpeaker?.name ?? "Select Speaker..."}
        </span>
      </SelectTrigger>
      <SelectContent>
        {speakers.map((speaker) => (
          <SelectItem key={speaker.id} value={speaker.id}>
            {speaker.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
